// extracted by mini-css-extract-plugin
export default {"main":"style_main__LiL0V","eventsContainer":"style_eventsContainer__wthi4","button":"style_button__ZnzNA","newButton":"style_newButton__iKlhH","icon":"style_icon__W50iA"};